import { InitialGeofence } from './user';
import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
export const mapAdapter = createEntityAdapter();

const initialRegion = {
    lat: 56.8773091,
    lng: 14.780480299999999,
};

const initialCamera = {
    center: {
        lat: 56.8773091,
        lng: 14.780480299999999,
    },
    altitude: 100,
    longitudeDelta: 15,
    pitch: 0,
    heading: 0,
};

export const mapFilterValues = {
    team: 'team',
    minifinder: 'minifinder',
    cameras: 'cameras',
    tags: 'tags',
    geofences: 'geofences',
    huntingGrounds: 'hunting_ground',
    forbiddenAreas: 'forbidden_area',
    subAreas: 'sub_area',
    dogGeofences: 'dogGeofences',
    properties: 'properties',
};

export const mapTypes = [
    // // {type: google.maps.},
    // {type: 'TOPOGRAPHIC_SE'},
    // {type: 'TOPOGRAPHIC'},
    // {type: 'TOPOGRAPHIC_NO'},
    // {type: 'TOPOGRAPHIC_FI'},
    // {type: MAP_TYPES.STANDARD},
    // {type: MAP_TYPES.TERRAIN},
    // {type: MAP_TYPES.HYBRID}
];

export type UserDevice = {
    latitude: number;
    longitude: number;
};

const INITIAL_STATE = {
    mapType: 'standard',
    mapFilters: [
        mapFilterValues.team,
        mapFilterValues.minifinder,
        mapFilterValues.tags,
        mapFilterValues.huntingGrounds,
        mapFilterValues.forbiddenAreas,
        mapFilterValues.subAreas,
        mapFilterValues.dogGeofences,
    ],
    disabledTagFilters: [] as any[],
    disabledDogFilters: [] as number[],
    disabledGroundFilters: [] as string[],

    currentPosition: null as unknown as UserDevice,
    zoom: 12,
    region: initialRegion,
    camera: initialCamera,
    mapLoaded: false,
    mapCenteringInProgress: false,
    mapCenteringType: 'activeDevice',
    activeTracking: {
        type: null,
        id: null,
    },
    clusterInfoDevices: [],
    geofenceEditor: true,
    geofenceToShow: InitialGeofence,

    WMSOfflineMode: false,
    WMSCachingEnabled: false,

    mapBounds: null,
    rotateEnabled: false,
    reanableMapRotation: false,
    triggerDevicePopup: false,
};

const mapReducer = createSlice({
    name: 'map',
    initialState: mapAdapter.getInitialState(INITIAL_STATE),
    reducers: {
        setMapFilters(state, action) {
            let newFilter = [];

            if (state.mapFilters.indexOf(action.payload) >= 0) {
                newFilter = state.mapFilters.filter((key) => key !== action.payload);
            } else {
                newFilter = [...state.mapFilters, action.payload];
            }

            state.mapFilters = newFilter;
        },
        setDisabledTagFilters(state, action) {
            let newFilter: string[] = [];

            if (typeof state.disabledTagFilters === 'undefined') {
                newFilter = [action.payload];
            } else {
                if (state.disabledTagFilters.indexOf(action.payload) >= 0) {
                    newFilter.push(...state.disabledTagFilters.filter((filter) => filter !== action.payload));
                } else {
                    newFilter = [...state.disabledTagFilters, action.payload];
                }
            }

            state.disabledTagFilters = newFilter;
        },
        setAllTagFiltersActive(state) {
            state.disabledTagFilters = [];
        },
        setTriggerDevicePopup(state, action) {
            state.triggerDevicePopup = action.payload;
        },

        setMapCurrentPosition(state, action) {
            state.currentPosition = action.payload;
        },
        setMapActiveTracking(state, action) {
            state.activeTracking = action.payload;
        },
        setMapZoom(state, action) {
            state.zoom = action.payload;
        },
        setMapRegion(state, action) {
            state.region = action.payload;
        },
        setMapCamera(state, action) {
            state.camera = action.payload;
        },
        resetMapRegion(state) {
            state.region = initialRegion;
        },
        setMapLoaded(state, action) {
            state.mapLoaded = action.payload;
        },
        setGeofenceEditor(state, action) {
            state.geofenceEditor = action.payload;
        },
        setMapBounds(state, action) {
            state.mapBounds = action.payload;
        },
        setMapCenteringInProgress(state, action) {
            state.mapCenteringInProgress = action.payload;
        },
        setGeofenceToShow(state, action) {
            state.geofenceToShow = action.payload;
        },
        setMapCenteringType(state, action) {
            state.mapCenteringType = action.payload;
        },
        setAllGroundFiltersActive(state) {
            state.disabledGroundFilters = [];
        },
        setAllGroundFiltersDisabled(state, action) {
            state.disabledGroundFilters = action.payload;
        },
        setAllTagFiltersDisabled(state, action) {
            state.disabledTagFilters = action.payload;
        },
        setAllDogFiltersDisabled(state, action) {
            state.disabledDogFilters = action.payload;
        },
        setDisabledDogFilters(state, action) {
            let newFilter: number[] = [];

            if (typeof state.disabledDogFilters === 'undefined') {
                newFilter = [action.payload];
            } else {
                if (state.disabledDogFilters.indexOf(action.payload) >= 0) {
                    newFilter.push(...state.disabledDogFilters.filter((filter) => filter !== action.payload));
                } else {
                    newFilter = [...state.disabledDogFilters, action.payload];
                }
            }

            state.disabledDogFilters = newFilter;
        },
        setAllDogFiltersActive(state) {
            state.disabledDogFilters = [];
        },
        setDisabledGroundFilters(state, action) {
            let newFilter: string[] = [];
            if (typeof state.disabledGroundFilters === 'undefined') {
                newFilter.push(action.payload);
            } else {
                if (state.disabledGroundFilters.indexOf(action.payload) >= 0) {
                    newFilter.push(...state.disabledGroundFilters.filter((filter) => filter !== action.payload));
                } else {
                    newFilter = [...state.disabledGroundFilters, action.payload];
                }
            }

            state.disabledGroundFilters = newFilter;
        },
    },
});

export const {
    setMapFilters,
    setDisabledTagFilters,
    setDisabledGroundFilters,
    setMapCurrentPosition,
    setMapZoom,
    setMapRegion,
    setMapCamera,
    resetMapRegion,
    setMapLoaded,
    setGeofenceEditor,
    setMapBounds,
    setMapCenteringInProgress,
    setMapCenteringType,
    setGeofenceToShow,
    setMapActiveTracking,
    setAllGroundFiltersActive,
    setAllGroundFiltersDisabled,
    setAllTagFiltersActive,
    setAllTagFiltersDisabled,
    setAllDogFiltersActive,
    setAllDogFiltersDisabled,
    setDisabledDogFilters,
    setTriggerDevicePopup,
} = mapReducer.actions;

export default mapReducer.reducer;
